import { useState as C, useRef as N, useEffect as f, useCallback as I } from "react";
const E = ({
  onSuccess: t,
  onError: e
}) => {
  const [o, s] = C(null);
  return {
    copiedText: o,
    copy: async (n) => {
      try {
        if (typeof navigator > "u" || !(navigator != null && navigator.clipboard))
          throw new Error("Clipboard not supported");
        return await navigator.clipboard.writeText(n), t(n), s(n), !0;
      } catch (c) {
        return console.warn("Copy failed:", c), e(), s(""), !1;
      }
    }
  };
}, R = (t, e = 500, o) => {
  const [s, r] = C(t), n = N(t);
  return f(() => {
    const c = setTimeout(() => {
      n.current !== t && (r(t), n.current = t, o && o());
    }, e);
    return () => {
      clearTimeout(c);
    };
  }, [t, e, o]), s;
}, T = "EC0000000", u = {
  INITIAL: "INITIAL",
  LOADING: "LOADING",
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
  NO_CONNECTION: "NO_CONNECTION"
}, h = (t, e = {}, o = !0) => {
  const [s, r] = C({}), [n, c] = C(!1), [d, a] = C(u.INITIAL), l = I((S) => {
    if (!navigator.onLine) {
      a(u.NO_CONNECTION);
      return;
    }
    a(u.LOADING), c(!0), t(S).then((i) => {
      i.err_code !== T ? (r(i), a(u.ERROR)) : (r(i), a(u.SUCCESS)), c(!1);
    }).catch((i) => {
      console.error(i), a(u.ERROR), c(!1);
    });
  }, [t, r, a]), O = I(() => {
    r({}), a(u.INITIAL);
  }, []);
  return f(() => {
    o && l(e);
  }, [l, o]), {
    status: d,
    loading: n,
    data: s,
    fetchData: l,
    resetData: O
  };
}, A = (t) => (e) => {
  const {
    scrollTop: o,
    scrollHeight: s,
    clientHeight: r
  } = e;
  (o + 20) / (s - r) > 1 && t();
}, L = (t) => {
  const e = N();
  return f(() => {
    e.current = t;
  }), e.current;
};
export {
  E as useCopyToClipboard,
  R as useDebounce,
  h as useFetch,
  A as useOnScrollReachesBottom,
  L as usePreviousState
};
